'use client';

import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import {
  EMPTY_VIEWPORT,
  type ViewportMetrics,
} from './viewport-metrics-measurement';
import {
  addViewportMetricsListeners,
  createViewportMetricsRafSync,
  primeViewportMetrics,
} from './viewport-metrics-sync';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export type { ViewportMetrics };

export function useViewportMetrics(): ViewportMetrics {
  const [metrics, setMetrics] = useState<ViewportMetrics>(EMPTY_VIEWPORT);
  const stableHeightRef = useRef(0);
  const stableWidthRef = useRef(0);

  useIsomorphicLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    primeViewportMetrics({ stableHeightRef, stableWidthRef, setMetrics });
  }, []);

  useEffect(() => {
    const rafSync = createViewportMetricsRafSync({ stableHeightRef, stableWidthRef, setMetrics });
    const removeViewportMetricsListeners = addViewportMetricsListeners(rafSync.sync);

    return () => {
      rafSync.cancelPendingFrame();
      removeViewportMetricsListeners();
    };
  }, []);

  return metrics;
}
